// extracted by mini-css-extract-plugin
export default {"Archiving":"Archiving_Archiving__FaN1K","boxes":"Archiving_boxes__J8wVO"};